import { OffboardingRecord, OffboardingStatus } from '@/features/offboarding/offboarding.def.ts'
import { Tag } from 'antd'
import React from 'react'

type OffboardingStatusTagProps = {
  data: OffboardingRecord
}

export const OffboardingStatusTag: React.FC<OffboardingStatusTagProps> = ({ data }) => {
  let color = 'default'
  switch (data.status) {
    case OffboardingStatus.InProgress:
      color = 'orange'
      break
    case OffboardingStatus.Completed:
      color = 'green'
      break
    case OffboardingStatus.Discarded:
      color = 'red'
      break
  }
  return <Tag color={color}>{data.status}</Tag>
}